app.service('productTabSendOnDevice',function(loading, productCardConfig, modal, validate, captchaService) {
	var $self;

	function send(form){
		var params = {
			cms_input_plu:productCardConfig.getData().plu,
			cms_input_links:window.location.pathname,
			emailId:'MOBI_PRODUCT_INFO',
		}
		$self.addClass('loading');
		$(form).ajaxSubmit({
			url:'/cmsPageFormSubmit.ltr',
			type:'POST',
			data:params,
			timeout:5000,
			success:function(json){
				$self.removeClass('loading');
				if(json.status == 'SUCCESS') {
					sendSuccess();
				}else{
					sendError(json.messages[0]);
				}
			},
			error:function(){
				$self.removeClass('loading');
				sendError();
			}
		});
	}
	function addSendOnDeviceCaptcha(){
		var $captcha = $self.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	
	function sendSuccess(){
		modal.alert('Wiadomość została wysłana', function(){
			UA.pageInteraction('Udostępnij i zapamiętaj', 'Wysłano');
			loading.reload();
		});
	}
	
	//	UX błędne wysłanie wiadomosci 
	function sendError(message = 'Nie udało się wysłać wiadomości'){
		modal.alert(message);
	}

	function setEvents(){
		$('body').on('click','#podziel-sie a[data-tab="podziel-sie"]', function(){
			addSendOnDeviceCaptcha();
			validate.task('sendOnDeviceForm',function(form){
				send(form);
			});
		});
	}
	function setElements(){
		$self=$('#send-on-device');
	}
	function init(){
		setElements();
		setEvents();
	}
	return {
		init:init
	};
});
